import { Link } from "react-router-dom";
import { AlertTriangle, Coins } from "lucide-react";
import { useTranslation } from "react-i18next";

const THRESHOLD = 15;

export const LowBalanceBanner = ({ balance }) => {
  const { t } = useTranslation();
  if (balance == null || balance >= THRESHOLD) return null;
  const empty = balance <= 0;
  return (
    <div className={`flex flex-col sm:flex-row sm:items-center gap-3 border px-4 py-3 mb-5 ${empty ? "border-red-300 bg-red-50" : "border-amber-300 bg-amber-50"}`} data-testid="low-balance-banner">
      <AlertTriangle className={`w-5 h-5 shrink-0 ${empty ? "text-red-500" : "text-amber-500"}`} />
      <p className="flex-1 text-sm text-slate-700">
        {empty ? t("lowBalance.empty") : t("lowBalance.message")}
        <span className="ml-2 inline-flex items-center gap-1 text-slate-500"><Coins className="w-3.5 h-3.5 text-amber-500" /> {balance}</span>
      </p>
      <Link to="/tokens" className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white px-4 py-2 text-xs font-bold uppercase tracking-wide transition-colors shrink-0" data-testid="low-balance-cta">
        <Coins className="w-4 h-4" /> {t("lowBalance.cta")}
      </Link>
    </div>
  );
};
